<script>
    import {
        solved, isMine
    } from "../stores/contractTreasure";

    import {
        _owners as buttonOwners,
        _my_tokens as myButtons,
    } from "../stores/contractButtons";
    import Solver from "./Solver.svelte";


</script>


<div>
    <h1>Treasure hunt</h1>
    <div>
        <p>If you own a button, you are able to participate in the hunt.</p>
        <p>There is an NFT contract with a 1/1 prize token that can only be claimed by submitting the correct password,
            and only by someone who owns a ButtonNFT</p>
        <p>
            Every ButtonNFT has its own corresponding password, so you can't cheat and frontrun someone else's password (there are other ways of preventing this for a common password)
        </p>
        <p>
            The validation is done on-chain (password hashes stored in contract).
        </p>
        <p>
            If you wanted to be really showy/encryptiony, you could have a server encrypt the first clue using the token holder's private key, so only they could decrypt it.
        </p>
        <p>
            Depending how complex you wanted the treasure hunt to be, you could have a clue that leads to another clue etc... Its possible to do this in a decentralised way using IPFS, but that's another conversation.
        </p>
        <p>
            This general mechanic (unlock NFT with password) is something I'm incorporating into a current side gig so I'd appreciate if you kept it quiet for now.
        </p>
        <p>
            For the purposes of this demo, it just tells you the password corresponding to any buttons you own.
        </p>

    </div>

    <div>
        <h3>The prize is the coveted  1/1 TreasureNFT</h3>
        <img src="winnerToken.png" alt="">
        
        {#if $solved}
            <div>It has been claimed</div>
            {#if $isMine}
                <div>You claimed it!</div>
            {/if}
        {:else }
            {#if $myButtons['1']}
                <Solver tokenId="1"/>
            {/if}
            {#if $myButtons['2']}
                <Solver tokenId="2"/>
            {/if}
            {#if $myButtons['3']}
                <Solver tokenId="3"/>
            {/if}
            {#if $myButtons['4']}
                <Solver tokenId="4"/>
            {/if}
        {/if}
    </div>


</div>